import FormPickerItem from './FormPickerItem';
import { connect } from 'react-redux';
import { Droppable, Draggable } from 'react-beautiful-dnd';

import { addFormField } from '@/_redux/actions/ActionForm';
import ID from '@/_helpers/uuid';
import { getOptionConfig } from '../smartpdf/utils';
import { defaultFormItems } from './DefaultFormElements';
import { Fragment } from 'react';

function defaultItemOptions(element) {
    switch (element) {
        case 'Select':
            return [
                { text: 'option 1', value: ID.uuid() },
                { text: 'option 2', value: ID.uuid() },
                { text: 'option 3', value: ID.uuid() },
            ];
        case 'Checkbox':
            return [
                {
                    text: 'option 1',
                    value: ID.uuid(),
                },
                {
                    text: 'option 2',
                    value: ID.uuid(),
                },
                {
                    text: 'option 3',
                    value: ID.uuid(),
                },
            ];
        case 'Radio':
            return [
                {
                    text: 'option 1',
                    value: ID.uuid(),
                },
                {
                    text: 'option 2',
                    value: ID.uuid(),
                },
                {
                    text: 'option 3',
                    value: ID.uuid(),
                },
            ];
        default:
            return [];
    }
}

export function buildElementOptions(item, { configData = {} } = {}) {
    const isCheckboxOrRadio = item.key === 'Checkbox' || item.key === 'Radio';
    if (!item?.type || !item?.label) {
        const tempItem = defaultFormItems().find((i) => i.key === item.key);
        item.type = tempItem.type;
        item.label = tempItem.label;
        if (tempItem.instruction) {
            item.instruction = tempItem.instruction;
        }
        if (tempItem.data) {
            item.data = tempItem.data;
        }
        if (tempItem.options) {
            item.options = tempItem.options;
        }
    }
    const elementOptions = {
        ...(isCheckboxOrRadio ? {} : configData?.data?.generic || {}),
        id: ID.uuid(),
        key: item.key,
        fieldName: item.label,
        type: item.type,
    };

    if (item.instruction) elementOptions['instruction'] = item.instruction;
    if (item.data) elementOptions['data'] = item.data;

    if (item.options) {
        elementOptions['data'] = defaultItemOptions(elementOptions['key']);
    }

    return elementOptions;
}
function FormPicker({
    teamId,
    openFormBuilder,
    smartpdfAllowedElements,
    handleOnEdit,
    configData = {},
    formId,
    addFormField,
    onCloseModal = () => {},
    draggable,
}) {
    const items = defaultFormItems();

    function _onClick(item) {
        let elementOptions = buildElementOptions(item, { configData });

        if (smartpdfAllowedElements) {
            const isCheckboxOrRadio = item.key === 'Checkbox' || item.key === 'Radio';

            if (isCheckboxOrRadio) {
                elementOptions.config = {
                    hasTemplateConfig: true,
                };
                elementOptions.data = (elementOptions.data || []).map((option, optionIndex) => {
                    const tempDataConfig = {
                        ...option,
                        ...(configData?.data ? getOptionConfig(optionIndex, configData?.page || 1) : {}),
                    };
                    tempDataConfig.config.parentFormElement = {
                        id: elementOptions?._id || elementOptions?.id,
                        key: elementOptions?.key,
                    };
                    return tempDataConfig;
                });
            }
            elementOptions.from = 'FormPicker';
            handleOnEdit({ field: elementOptions });
        } else {
            addFormField(elementOptions, { formId, action: 'add', hideSavingAlert: true, from: 'FormPicker' });
        }
        onCloseModal();
    }

    return (
        <div>
            {/* <div css={formPickerHeader} className="d-flex flex-row justify-content-between">
                <h5
                    onClick={() => {
                        if (!openFormBuilder) return handleOpen();
                        else return null;
                    }}
                    className='text-center align-items-center d-flex flex-row justify-center'
                >
                    Form Elements
                </h5>
            </div> */}
            {openFormBuilder && (
                <div
                    style={{
                        overflowY: 'auto',
                        height: '80vh',
                        maxHeight: '80vh',
                        position: 'relative',
                    }}
                >
                    {Object.entries(
                        items
                            .filter((item) => !smartpdfAllowedElements || smartpdfAllowedElements.includes(item.key))
                            .reduce((groups, item) => {
                                const group = item.group || 'Other.Elements';
                                if (!groups[group]) {
                                    groups[group] = [];
                                }
                                groups[group].push(item);
                                return groups;
                            }, {})
                    ).map(([groupName, groupItems]) => (
                        <div
                            key={groupName}
                            style={{
                                border: '1px solid #000',
                                marginTop: '8px',
                            }}
                        >
                            {/* Group header */}
                            <div
                                style={{
                                    padding: '8px 12px',
                                    backgroundColor: '#50aeb0',
                                    fontWeight: 'bold',
                                    textTransform: 'capitalize',
                                    fontSize: '1.6rem',
                                    color: '#fff',
                                }}
                            >
                                {groupName.replaceAll('.', ' ')}
                            </div>

                            {/* Group items */}
                            {groupItems.map((item, index) => (
                                <Fragment>
                                    {draggable ? (
                                        <Droppable droppableId="formPicker" isDropDisabled={true} key={item.key}>
                                            {(provided) => (
                                                <div ref={provided.innerRef} {...provided.droppableProps}>
                                                    <Draggable key={item.key} draggableId={item.key} index={index}>
                                                        {(provided) => (
                                                            <div
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                            >
                                                                <div onClick={() => _onClick(item)}>
                                                                    <FormPickerItem data={item} cursor={'all-scroll'} />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                </div>
                                            )}
                                        </Droppable>
                                    ) : (
                                        <div onClick={() => _onClick(item)}>
                                            <FormPickerItem data={item} cursor={'all-scroll'} />
                                        </div>
                                    )}
                                </Fragment>
                            ))}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

const mapStateToProps = (state) => ({
    formElements: state.formData.formElements,
    teams: state.teams.teams,
    teamRooms: state.rooms.teamRooms,
    currUser: state.user.user,
});

const mapDispatchToProps = {
    addFormField,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormPicker);
